exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content{padding:80px 0 0}.section-padding{display:block}.questions-area{background:#f9f9f9 none repeat scroll 0 0;text-align:center}.questions-area button{margin-top:30px}@media only screen and (max-width: 768px){.section-title p{width:90%;padding:0px 10px}}.footer{background:#272a31 none repeat scroll 0 0;padding:40px 0}.footer_copyright{color:#fff;padding-top:30px;text-transform:capitalize}.footer_copyright a{color:#fff}.logo{width:250px;height:36px;text-decoration:none}", ""]);

// exports
